import { integration } from '@yola/ws-sdk';

const getOnlineStoreLimit = (state) => integration.selectors.getLimits(state).onlineStore;

export default getOnlineStoreLimit;
